import { SimpleQuestion } from './simple-question.model';
import { CategoryMapper } from './category.mapper';
import { AnswerMapper } from './answer.mapper';

export class SimpleQuestionMapper {
  public static map(simpleQuestionData: any): SimpleQuestion {
    if (!simpleQuestionData) {
      return null;
    }

    if (!Array.isArray(simpleQuestionData.answers)) {
      simpleQuestionData.answers = [];
    }

    return new SimpleQuestion (
        simpleQuestionData.id,
        simpleQuestionData.type,
        simpleQuestionData.order,
        simpleQuestionData.content,
        simpleQuestionData.secondaryContent,
        simpleQuestionData.comment,
        CategoryMapper.map(simpleQuestionData.category),
        simpleQuestionData.answers
        .map(AnswerMapper.map)
        .sort((firstAnswer, secondAnswer) => firstAnswer.order - secondAnswer.order),
        simpleQuestionData.userAnswers,
        simpleQuestionData.categoryVisible
      );
    }
}



// WEBPACK FOOTER //
// /dist/src/app/question/simple-question.mapper.ts